import { makeStyles } from '@material-ui/core/styles';

export const useFormSelectHtmlTemplateStyles = makeStyles(theme => ({
  formField: {
    flexGrow: 1
  }
}));
